export const compareOptionText = (left?: string | null, right?: string | null) =>
  (left ?? "").localeCompare(right ?? "", undefined, {
    sensitivity: "base",
    numeric: true,
  });

export const sortByText = <T>(items: T[], selector: (item: T) => string | null | undefined) =>
  [...items].sort((left, right) => compareOptionText(selector(left), selector(right)));
